module.exports = __webpack_public_path__ + "img/pro_2.cdf3266d.png";